import type { CSSProperties } from 'react';

import { PictureComponentV2 } from 'app/components/commons/PictureComponentV2/PictureComponentV2';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

import styles from './SingleImage.module.scss';

const DEFAULT_IMAGE_SIZE = 32;

type SingleImageProps = {
  image: PictureView;
  width?: number;
  height?: number;
};

type SingleImageStyle = CSSProperties & {
  '--single-image-width'?: string;
  '--single-image-height'?: string;
};

export const SingleImage = ({ image, width, height }: SingleImageProps) => {
  const hasCustomSize = width !== undefined || height !== undefined;
  const imageWidth = width ?? height ?? DEFAULT_IMAGE_SIZE;
  const imageHeight = height ?? width ?? DEFAULT_IMAGE_SIZE;
  const style: SingleImageStyle | undefined = hasCustomSize
    ? {
        '--single-image-width': `${imageWidth}px`,
        '--single-image-height': `${imageHeight}px`,
      }
    : undefined;

  return (
    <div className={styles.singleImage} style={style}>
      <div className={styles.imageContainer}>
        <PictureComponentV2
          path={image.path}
          alt={image.alt}
          width={hasCustomSize ? imageWidth : undefined}
          height={hasCustomSize ? imageHeight : undefined}
        />
      </div>
    </div>
  );
};
